import BarChartWithInfoSnippets from '../BarChartWithInfoSnippets';
import withErrorBoundary from '../ErrorBoundary';

import type { CarHireMostPopularMakerProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/CarHireMostPopularMakerProps';

const CarHireMostPopularMaker = (props: CarHireMostPopularMakerProps) => (
  <BarChartWithInfoSnippets {...props} testId="carHireMostPopularMaker" />
);

export default withErrorBoundary(
  CarHireMostPopularMaker,
  'car-hire-most-popular-maker-component',
);
